module.exports = __webpack_public_path__ + "img/droplets-01.0d8c0905.svg";